module.exports = __webpack_public_path__ + "img/65.14d46e40.jpg";